export const BootstrapVueConfig = {
    BModal: {
        returnFocus: "body"
    }
};